import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 查询隐私政策列表
 */
export const getPrivacyList = () => {
  return request('GET', `${baseUrl}/api/auth/system/privacy/list`);
};

/**
 * 新增隐私政策
 */
export const savePrivacyPolicy = data => {
  return request('POST', `${baseUrl}/api/auth/system/privacy/save`, data);
};

/**
 * 编辑隐私政策
 */
export const editPrivacyPolicy = data => {
  return request('POST', `${baseUrl}/api/auth/system/privacy/edit`, data);
};

/**
 * 删除隐私政策
 */
export const deletePrivacyPolicy = data => {
  return request('POST', `${baseUrl}/api/auth/system/privacy/del`, data);
};

/**
 * 获取当前系统已激活的隐私政策
 */
export const getCurrentPrivacyPolicy = () => {
  return request('GET', `${baseUrl}/api/auth/system/privacy/current`);
};

/**
 * 根据主键查询隐私政策
 */
export const getPrivacyPolicyById = params => {
  return request('GET', `${baseUrl}/api/auth/system/privacy/get`, params);
};

/**
 * 启用隐私政策
 */
export const activatePrivacyPolicy = data => {
  return request('POST', `${baseUrl}/api/auth/system/privacy/active`, data);
};

/**
 * 确认隐私政策
 */
export const confirmPrivacyPolicy = data => {
  return request('POST', `${baseUrl}/api/auth/sys/user/owner/privacy`, data);
};
